import { render } from "./StandardV2BannerCarousel.vue?vue&type=template&id=96b13f4c&scoped=true"
import script from "./StandardV2BannerCarousel.vue?vue&type=script&lang=js"
export * from "./StandardV2BannerCarousel.vue?vue&type=script&lang=js"

import "./StandardV2BannerCarousel.vue?vue&type=style&index=0&id=96b13f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b13f4c"]])

export default __exports__